import React, { useRef, useEffect, useState, useCallback, useContext } from 'react';
import { ActionCableConsumer } from 'react-actioncable-provider';
import { notificationConstants } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import useSound from 'use-sound';
import notificationSound from '../../../sounds/notification-ring.mp3';
import ActionCable from 'actioncable';
import { SoundContext } from '../../../providers/AudioProvider';

function NotificationActionCable(props) {
  // Variables
  const dispatch = useDispatch();
  const [play, { stop }] = useSound(notificationSound);
  const cableUrl = process.env.REACT_APP_CABLE_URL;

  // Redux
  const user_id = useSelector(state => state.dashboard.currentUser);
  const enable_notification_ring = useSelector(state => state.notification.enable_notification_ring);

  // States
  const [subscription, setSubscription] = useState(null);

  // Context
  const { audioContextReady } = useContext(SoundContext);

  // Refs
  const cableRef = useRef(null);
  const subscriptionRef = useRef(null);
  const audioContextReadyRef = useRef();
  const enable_notification_ringRef = useRef();
  audioContextReadyRef.current = audioContextReady;
  enable_notification_ringRef.current = enable_notification_ring;


  // Functions
  const updateActionCable = async (payload) => {
    // wait this function until its finished
    await dispatch({ type: notificationConstants.GET_ACTION_CABLE_NOTIFICAIONS, payload: payload });
    dispatch({ type: notificationConstants.SET_NEW_NOTIFICATION, payload: payload });

    // wait 500 ms
    setTimeout(() => playSound(payload), 500);
  };

  const playSound = (payload ) => {
    const notification = payload;
        
    if(
        notification?.is_read === false && 
        notification?.summary !== "-" && 
        notification?.viewable && 
        enable_notification_ringRef.current && 
        notification?.is_sound_enabled
      ){
      if (audioContextReadyRef.current) {
        console.log("Notif sound")
        
        const audio = new Audio(notificationSound);
        audio.play();
      } else {
        console.log("Audio not ready")
      }
    }
  }
  
  const handleReceivedLists = (res) => {
    if(res?.deleted){
      dispatch({ type: notificationConstants.DELETE_ACTION_CABLE_NOTIFICATIONS, payload: res.data })
    } else {
      updateActionCable(res?.data)
    }
  };

  useEffect(() => {
      if (!cableUrl) {
          console.warn("REACT_APP_CABLE_URL is not set; ActionCable will not connect.");
          return;
      }

      if (!cableRef.current) {
          cableRef.current = ActionCable.createConsumer(cableUrl);
      }

      return () => {
          // disconnect the consumer when the component unmounts
          if (cableRef.current?.disconnect) cableRef.current.disconnect();
          cableRef.current = null;
      };
  }, [cableUrl]);
  

    useEffect(() => {
      // unsubscribe previous subscription if any
      if (subscriptionRef.current && cableRef.current?.subscriptions) {
          try {
              cableRef.current.subscriptions.remove(subscriptionRef.current);
          } catch (err) {
              console.warn("Failed to remove previous subscription", err);
          }
          subscriptionRef.current = null;
      }

      if (!user_id || !cableRef.current) return;

      const channel = { channel: "NotificationChannel", user_id: user_id.id };

      subscriptionRef.current = cableRef.current.subscriptions.create(channel, {
          received: handleReceivedLists,
          connected: () => console.log("Connected to NotificationChannel"),
          disconnected: () => console.log("Disconnected from NotificationChannel"),
      });

      console.log("Subscribed to NotificationChannel for user:", user_id.id);

      return () => {
          if (subscriptionRef.current && cableRef.current?.subscriptions) {
              try {
                  cableRef.current.subscriptions.remove(subscriptionRef.current);
                  console.log("Unsubscribed from NotificationChannel");
              } catch (err) {
                  console.warn("Failed to remove subscription on cleanup", err);
              }
              subscriptionRef.current = null;
          }
      };
  }, [user_id]);

  return null
}

export default NotificationActionCable



